import { useMobileByScreenSize } from '@/utils';

export default {
    install(Vue, options) {
        const { isMobile } = useMobileByScreenSize();
        Vue.prototype.$isMobile = isMobile.value;
    },
};
